import { CoreEnums } from '@/utils/domain/constants';
import {
  AppstoreAddOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
  ProjectOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';

export const menuIcons = {
  [CoreEnums.PortalMenuItemType.CustomList]: <UnorderedListOutlined />,
  [CoreEnums.PortalMenuItemType.DynamicEntity]: <DatabaseOutlined />,
  [CoreEnums.PortalMenuItemType.Process]: <AppstoreOutlined />,
  [CoreEnums.PortalMenuItemType.Report]: <ProjectOutlined />,
  [CoreEnums.PortalMenuItemType.App]: <AppstoreAddOutlined />,
};

export const routing = Object.freeze({
  [CoreEnums.PortalMenuItemType.CustomLists]: { path: '/custom-lists', icon: 'List' },
  [CoreEnums.PortalMenuItemType.Processes]: { path: '/processes', icon: 'Device-hub' },
  [CoreEnums.PortalMenuItemType.Reports]: { path: '/reports', icon: 'Insert-chart' },
  [CoreEnums.PortalMenuItemType.CustomList]: {
    path: '/custom-lists/view?listId=',
    id: 'customListId',
    icon: CoreEnums.PortalMenuItemType.CustomList,
  },
  [CoreEnums.PortalMenuItemType.DynamicEntity]: {
    path: '/entities/',
    id: 'dynamicEntityId',
    icon: CoreEnums.PortalMenuItemType.DynamicEntity,
  },
  [CoreEnums.PortalMenuItemType.Process]: {
    path: '/processes/start?ProcessId=',
    id: 'processId',
    icon: CoreEnums.PortalMenuItemType.Process,
  },
  [CoreEnums.PortalMenuItemType.Report]: {
    path: '/reports/',
    id: 'parentId,groupId,reportId',
    icon: CoreEnums.PortalMenuItemType.Report,
  },
  [CoreEnums.PortalMenuItemType.Apps]: { path: '/portal/apps', icon: 'Apps' },
  [CoreEnums.PortalMenuItemType.App]: {
    path: '/apps/',
    id: 'appId',
    icon: CoreEnums.PortalMenuItemType.App,
  },
});
